module.exports = __webpack_public_path__ + "fonts/SFUIText-LightItalic.3fceb701.woff2";